import { useState } from "react";

import { useToasts } from "react-toast-notifications";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { useSavedViews } from "@features/sales-v3/hooks";
import { PrimaryButton, SecondaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UpdateSavedViewsModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: Props) => {
  const prettyLogEventPage = usePrettyLogEventPage();
  const { updateSavedViewConfig } = useSavedViews();
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToasts();

  const saveSavedView = async () => {
    prettyLogEventPage({
      domain: "Top Level Filters",
      action: "onChange",
      additionalActionInfo: "Update Saved View",
    });

    try {
      setIsSaving(true);
      await updateSavedViewConfig();
      onConfirm();
      toast.addToast("Saved view updated", { appearance: "success" });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      headerTitleProps={{ className: "text-xl font-semibold" }}
      titleContent={
        <div>Overwrite current view for all users on your account?</div>
      }
    >
      <p className="text-sm mb-8 text-[#717680]">Changes cannot be undone</p>
      <div className="flex space-x-3">
        <PrimaryButton loading={isSaving} onClick={saveSavedView}>
          YES, SAVE
        </PrimaryButton>
        <SecondaryButton disabled={isSaving} onClick={onCancel}>
          NO, CANCEL
        </SecondaryButton>
      </div>
    </Modal>
  );
};
